import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import evenementsData from '../data/evenements.json';
import etoilesData from '../data/etoiles.json';
import firststandData from '../data/firststand.json';
import msiData from '../data/msi.json';
import worldsData from '../data/worlds.json';
import EvenementModel from '../models/evenement';
import EquipeModel from '../models/equipe';
import MatchModel from '../models/match';
import Header from '../widgets/molecules/header';
import Match from '../widgets/atomes/match';
import ListeMatchs from '../widgets/molecules/listeMatchs';
import Winner from '../widgets/atomes/winner';
function EvenementPage() {
    const { titre } = useParams();
    const navigate = useNavigate();
    const liens = etoilesData.etoiles.map(e => e.lien);
    const evenementData = evenementsData.evenements.find(event => event.titre === titre);

    const getTournamentData = () => {
        switch(titre) {
            case 'First Stand':
                return firststandData;
            case 'MSI':
                return msiData;
            case 'Worlds':
                return worldsData;
            default:
                return null;
        }
    };

    const tournamentData = getTournamentData();

    if (!evenementData) {
        return (
            <>
                <div className="bg-image"></div>
                <div className="flex flex-col min-h-screen md:h-screen text-white relative">
                    <Header etoiles={liens}/>
                <div className="flex flex-col flex-1 px-4 md:px-8 pt-4 md:pt-8 overflow-y-auto max-w-4xl mx-auto w-full">
                    <button
                        onClick={() => navigate('/')}
                        className="flex items-center gap-2 mb-4 hover:opacity-80 transition-opacity"
                    >
                        <span className="text-2xl">←</span>
                        <span className="text-lg">Retour</span>
                    </button>
                        <div className="bg-[#1A1A1A] bg-opacity-70 rounded-lg p-6 backdrop-blur-sm border border-gray-700">
                            <p className="text-2xl">Événement non trouvé</p>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    const evenement = EvenementModel.fromJSON(evenementData);

    return (
        <>
            <div className="bg-image"></div>
            <div className="flex flex-col min-h-screen md:h-screen text-white relative">
                <Header etoiles={liens}/>
                <div className="bg-[#1A1A1A] bg-opacity-70 backdrop-blur-sm border-b border-gray-700 px-4 md:px-8 py-3 md:py-4">
                    <div className="flex items-center gap-3 md:gap-6">
                        <button
                            onClick={() => navigate('/')}
                            className="flex items-center gap-2 hover:opacity-80 transition-opacity flex-shrink-0"
                        >
                            <span className="text-3xl md:text-4xl">←</span>
                        </button>

                        <div className="flex items-center gap-3 md:gap-6 flex-1 flex-wrap">
                            <img
                                src={`${process.env.PUBLIC_URL}/images/evenements/${evenement.logo}`}
                                alt={evenement.titre}
                                className="w-14 h-14 md:w-20 md:h-20 rounded-lg shadow-lg flex-shrink-0"
                            />

                            <div className="text-left md:text-center flex-1">
                                <h1 className="text-lg md:text-2xl font-bold mb-1 md:mb-3 font-poppins">{evenement.titre}</h1>

                                <div className="flex flex-wrap gap-3 md:gap-6 text-sm items-center">
                                    <div className="flex gap-2 text-gray-300">
                                        <span>{evenement.payslieu}</span>
                                        <span>•</span>
                                        <span>{evenement.lieu}</span>
                                    </div>

                                    <div className="flex gap-4 md:gap-6">
                                        <div>
                                            <p className="text-gray-400 text-xs mb-0.5">Début</p>
                                            <p className="font-semibold">{new Date(evenement.date).toLocaleDateString('fr-FR', { weekday: 'short', month: 'short', day: 'numeric' })}</p>
                                        </div>

                                        {evenement.dateFin && (
                                            <div>
                                                <p className="text-gray-400 text-xs mb-0.5">Fin</p>
                                                <p className="font-semibold">{new Date(evenement.dateFin).toLocaleDateString('fr-FR', { weekday: 'short', month: 'short', day: 'numeric' })}</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col flex-1 px-4 md:px-8 pt-4 md:pt-8 overflow-y-auto w-full">

                    {tournamentData && (
                        <div className="w-full">
                            {tournamentData.matchs && tournamentData.matchs.slice(0, -1).length > 0 && (
                                <ListeMatchs titre="Demis-finales" collapsedByDefault={true}>
                                    {tournamentData.matchs.slice(0, -1).map((match) => {
                                        const equipes = tournamentData.equipes.map(e => EquipeModel.fromJSON(e));
                                        return (
                                            <Match 
                                                key={match.id} 
                                                match={MatchModel.fromJSON(match)} 
                                                equipes={equipes}
                                            />
                                        );
                                    })}
                                </ListeMatchs>
                            )}

                            {tournamentData.matchs && tournamentData.matchs.length > 0 && (
                                <ListeMatchs titre="Finale">
                                    {tournamentData.matchs.slice(-1).map((match) => {
                                        const equipes = tournamentData.equipes.map(e => EquipeModel.fromJSON(e));
                                        return (
                                            <Match 
                                                key={match.id} 
                                                match={MatchModel.fromJSON(match)} 
                                                equipes={equipes}
                                            />
                                        );
                                    })}
                                </ListeMatchs>
                            )}

                            {tournamentData.matchs && tournamentData.matchs.length > 0 && (
                                (() => {
                                    const finalMatch = tournamentData.matchs[tournamentData.matchs.length - 1];
                                    let winnerId = null;
                                    
                                    if (finalMatch.score1 === 3) {
                                        winnerId = finalMatch.equipe1;
                                    } else if (finalMatch.score2 === 3) {
                                        winnerId = finalMatch.equipe2;
                                    }
                                    
                                    if (winnerId) {
                                        const winner = tournamentData.equipes.find(e => e.id === winnerId);
                                        return <Winner equipe={winner} />;
                                    }
                                    return null;
                                })()
                            )}
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}

export default EvenementPage;
